<template>
  <div class="tile is-ancestor footer-padding">
    <div class="tile is-parent is-vertical is-6">
      <tile v-for="[title, options] in evenQualificationItems"
          :key="title"
          :title="title"
          subtitle="Select the options that match your profile">
        <TagSelect :items="options"
          :activeList="edittedQualifications"
          @toggle="(s) => toggleQualification(s)"/>
      </tile>
    </div>
    <div class="tile is-parent is-vertical is-6">
      <tile v-for="[title, options] in oddQualificationItems"
        :key="title"
        :title="title"
        subtitle="Select the options that match your profile">
        <TagSelect :items="options"
        :activeList="edittedQualifications"
        @toggle="(s) => toggleQualification(s)"/>
      </tile>
      <tile title="Other" subtitle="Input your custom qualifications">
        <b-taginput
          :value="otherQualifications"
          @add="toggleQualification"
          @remove="toggleQualification"
          icon="label"
          type="is-primary"
          placeholder="Add a qualification">
        </b-taginput>
      </tile>
    </div>
    <Footer>
      <a :class="[
        'button', 'is-medium',
        'is-primary', loading && 'is-loading']"
        :disabled="!hasChanges"
        @click="save">
        Save
      </a>
    </Footer>
  </div>
</template>


<script>
import Tile from '@/components/Tile';
import Footer from '@/components/Footer';
import { mapState, mapActions, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import TagSelect from '@/components/TagSelect';


export default {
  components: {
    Tile,
    Footer,
    TagSelect,
  },
  data() {
    return {
      loading: false,
      edittedQualifications: [],
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      profile: state => state.auth.user.profile,
      qualifications: state => state.content.qualifications,
    }),
    ...mapGetters({
      qualificationsSet: 'content/qualificationsSet',
    }),
    qualificationItems() {
      return Object.entries(this.qualifications);
    },
    qualificationsItemsPerType() {
      return {
        owner: this.qualificationItems,
        crew: this.qualificationItems,
        diver: this.qualificationItems.filter(([key]) => ['Diving', 'Specialised Diving'].indexOf(key) !== -1),
        charterer: this.qualificationItems,
        on_dock: this.qualificationItems.filter(([key]) => key === 'Engineer'),
      }[this.user.type];
    },
    evenQualificationItems() {
      return this.qualificationsItemsPerType.filter((_, i) => i % 2 === 0);
    },
    oddQualificationItems() {
      return this.qualificationsItemsPerType.filter((_, i) => i % 2 === 1);
    },
    hasChanges() {
      return !isEqual(this.edittedQualifications, this.profile.qualifications);
    },
    otherQualifications() {
      return this.edittedQualifications.filter(q => !this.qualificationsSet.has(q));
    },
  },
  methods: {
    ...mapActions({
      updateProfile: 'auth/updateProfile',
    }),
    initialize() {
      this.edittedQualifications = cloneDeep(this.profile.qualifications);
    },
    toggleQualification(qualification) {
      const index = this.edittedQualifications.indexOf(qualification);
      if (index === -1) {
        this.edittedQualifications.push(qualification);
      } else {
        this.edittedQualifications.splice(index, 1);
      }
    },
    async save() {
      this.loading = true;

      try {
        await this.updateProfile({
          id: this.profile.id,
          qualifications: this.edittedQualifications,
        });
      } catch (e) {
        this.$toast.open({
          message: 'Could not save the personal info',
          type: 'is-danger',
        });
      }
      this.initialize();
      this.loading = false;
    },
  },
  created() {
    this.initialize();
  },
};

</script>

<style lang="scss" scoped>

</style>
